import { render, staticRenderFns } from "./AutomatedMessages.vue?vue&type=template&id=5a129941&scoped=true&"
import script from "./AutomatedMessages.vue?vue&type=script&lang=js&"
export * from "./AutomatedMessages.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedMessages.vue?vue&type=style&index=0&id=5a129941&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a129941",
  null
  
)

export default component.exports